import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import { IAIPetProfileCustomerResponse, IAIPetProfileCustomerResponseData } from "@/api_framework/api_modals/Users";

AxiosCurlirize(axios, () => {});
export const useAICustomerDetailsAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const [aiCustomerDetails, setAICustomerDetails] = useState<IAIPetProfileCustomerResponseData | null>(null);
  const [isAICustomerDetailsLoading, setIsAICustomerDetailsLoading] = useState(false);

  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (user_id: string) => {
      try {
        setIsAICustomerDetailsLoading(true);
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: IAIPetProfileCustomerResponseData | null = await axios
          .get(`${CUSTOMER_APIS?.AI_PET_PROFILE_FOR_CUSTOMER?.baseURL ?? ""}${user_id}`, {
            // params: {
            //   user_id: user_id,
            // },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IAIPetProfileCustomerResponse>) => {
            if (res.data?.user_id) {
              setAICustomerDetails(res.data);
              return res.data;
            } else {
              setAICustomerDetails(null);
              return null;
            }
          })
          .catch((e: AxiosError) => {
            setAICustomerDetails(null);
            captureError(e);
            sendCurl(e.config?.["curlCommand"]);

            return null;
          });
        return response;
      } catch (e: any) {
        setAICustomerDetails(null);
        toast.error("Server Error: " + e.message);
      } finally {
        setIsAICustomerDetailsLoading(false);
      }
    },
    [dispatch],
  );
  return { execute, aiCustomerDetails, isAICustomerDetailsLoading };
};
